<template>
  <Modal :title="'Join Session'" v-model="isSessionJoinModalOpen">
    <section>
      <div class="relative">
        <img
          class="object-cover w-96 h-56"
          :src="session_thumbnail_url"
          alt="..."
          @error="defaultImage"
        />
      </div>
      <!-- <button
        v-if="this.wallet_balance != null && showCancelButton"
        @click="handleSessionJoinModal(false)"
        class="absolute top-0 right-0 mt-2 mr-2 bg-gray-500 text-white rounded-md p-1 focus:outline-none"
      >
        <X />
      </button> -->
      <p class="text-center text-gray-dark text-xl font-medium mt-4 capitalize">
        {{ sessionTitle }}
      </p>
      <div class="text-center">
        <div class="py-3">
          <p class="text-base text-gray-350">
            {{ sessionDate }}
          </p>
          <h3 class="text-lg text-gray-350 font-medium">
            {{ sessionTime }}
          </h3>
        </div>
        <p class="font-semibold text-gray-350 text-2xl" v-if="sessionCost != 0">
          ${{ sessionCost }}
        </p>
        <p class="font-semibold text-gray-350 text-2xl" v-if="sessionCost == 0">
          {{ "Free" }}
        </p>
        <section>
          <button
            class="uppercase bg-green-light w-72 text-base text-white mt-4 py-1 px-4 rounded"
            v-if="sessionCost == 0"
            @click="handleJoinClick"
          >
            Join
          </button>
          <button
            class="uppercase bg-green-light w-72 text-base text-white mt-4 py-1 px-4 rounded"
            v-if="
              sessionCost <= wallet_balance &&
              sessionCost > 0 &&
              paymentEnableDisable
            "
            @click="handleJoinClick"
          >
            Pay
          </button>
          <!-- opacity-50 -->
          <button
            type="button"
            class="uppercase bg-green-light w-72 text-base text-white mt-4 py-1 px-4 rounded"
            v-else-if="
              sessionCost >= wallet_balance &&
              paymentEnableDisable &&
              sessionCost != 0
            "
            @click="handleAddMoney"
          >
            Pay
          </button>
          <div v-else-if="!paymentEnableDisable && sessionCost != 0">
            <button
              type="button"
              class="uppercase bg-green-light w-72 text-base text-white mt-4 py-1 px-4 rounded"
              @click="handleJoinClick"
            >
              SUBSCRIBE FREE
            </button>
            <div class="text-red-900 text-center m-auto mt-4">
              Payment Is Currently Disabled.
            </div>
            <div class="text-red-900 text-center m-auto">
              There Will Be No Deduction From Your Wallet.
            </div>
          </div>
          <p
            class="text-gray-350 text-xs mt-2"
            v-if="sessionCost != 0 && paymentEnableDisable"
          >
            You have
            <span :class="{ 'font-bold': sessionCost > wallet_balance }"
              >${{ wallet_balance }}</span
            >
            in your account
          </p>
          <!-- <button
            class="uppercase text-xs text-gray-dark font-bold w-32 ring-1 ring-gray-dark mt-3 py-1 px-4 rounded-full"
            @click="handleAddMoney"
            v-if="sessionCost != 0 && paymentEnableDisable"
          >
            Add Money
          </button> -->
        </section>
      </div>
    </section>
  </Modal>
</template>

<script>
import { Modal } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SessionJoinModal",
  components: {
    Modal,
  },
  props: {
    isSessionJoinModalOpen: Boolean,
    handleSessionJoinModal: Function,
    session_thumbnail_url: String,
    sessionTitle: String,
    sessionDate: String,
    sessionTime: String,
    sessionCost: Number,
    wallet_balance: String,
    handleJoinClick: Function,
    handleAddMoney: Function,
    showCancelButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      paymentEnableDisable: "",
    };
  },
  computed: {
    ...mapGetters(["checkPaymentEnableOrDisable"]),
  },

  methods: {
    ...mapActions(["getCheckPaymentEnableOrDisable"]),

    handleCancel() {
      this.modalOpen = false;
    },

    handleEdit() {
      this.modalOpen = false;
      this.$emit("data", true);
    },
  },
  async created() {
    try {
      await this.getCheckPaymentEnableOrDisable();
      this.checkPaymentEnableOrDisable.forEach((element) => {
        //if value == 0 then payment is disable if value == 1 then payment is enabled
        if (element.key == "payment") {
          if (element.value == "0") this.paymentEnableDisable = "";
          else this.paymentEnableDisable = element.value;
        }
      });
    } catch (e) {
      console.log(e);
    }
  },
};
</script>